import "swiper/css";
import "swiper/css/navigation";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NewRelease from "./NewRelease";
import Trending from './Trending';
import RacingGames from './RacingGames';
import MindMining from './MindMining';

function ProfileCard() {

    const [profileCount, setProfileCount] = useState(0);
    const [gameCount, setGameCount] = useState(0);
    const [rewardCount, setRewardCount] = useState(0);

    const animateCount = (target, setter, duration = 3000) => {
        const increment = target / (duration / 16);
        let current = 0;

        const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
                setter(target);
                clearInterval(timer);
            } else {
                setter(Math.floor(current));
            }
        }, 16);
    };

    useEffect(() => {
        animateCount(28328, setProfileCount, 5000);
        animateCount(383, setGameCount, 5000);
        animateCount(2956, setRewardCount, 5000);
    }, []);

    const formatNumber = (num) => {
        return num.toLocaleString();
    };

    const navigate = useNavigate();

    return (
        <>
        <style>{`
          .card:hover {
            transform: translateY(-5px);
          }
        `}</style>

        <div className='relative w-full h-full bg-[#0f0f17] py-20'>

            {/* ===== TOP CARDS ===== */}
            <div className='absolute z-10 top-2 md:-top-16 lg:-top-16 left-1/2 -translate-x-1/2 w-full px-4'>
                <div className="flex items-center justify-center">
                    <div className='flex items-center gap-5 flex-wrap'>

                        {/* CARD 1 */}
                        <div className="card cursor-pointer bg-[#141422] w-full sm:w-[300px] md:w-[320px] lg:w-[340px] rounded-[14px] h-auto sm:h-[130px] lg:h-[142px] flex items-center px-4 sm:px-6 
                        border border-[#ff003c]/30 
                        shadow-[0_10px_25px_rgba(255,0,60,0.15)]
                        hover:shadow-[0_0_25px_rgba(255,0,60,0.4)]
                        transition-all duration-300">

                            <div className='flex items-center gap-4'>
                                <div className='p-3 rounded-lg bg-[#1f1f35]'>
                                    <img src="./assets/images/icon/c1.png" className="w-10 h-10 sm:w-12 sm:h-12" />
                                </div>

                                <div>
                                    <h2 className='text-white text-2xl sm:text-3xl lg:text-4xl font-bold'>
                                        {formatNumber(profileCount)}
                                    </h2>

                                    <p className='text-sm font-medium mt-1 bg-gradient-to-r from-[#ff003c] to-[#6a00ff] bg-clip-text text-transparent'>
                                        Profiles Created
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* CARD 2 */}
                        <div className="card cursor-pointer bg-[#141422] w-full sm:w-[300px] md:w-[320px] lg:w-[340px] rounded-[14px] h-auto sm:h-[130px] lg:h-[142px] flex items-center px-4 sm:px-6 
                        border border-[#ff003c]/30 
                        shadow-[0_10px_25px_rgba(255,0,60,0.15)]
                        hover:shadow-[0_0_25px_rgba(255,0,60,0.4)]
                        transition-all duration-300">

                            <div className='flex items-center gap-4'>
                                <div className='p-3 rounded-lg bg-[#1f1f35]'>
                                    <img src="./assets/images/icon/c2.png" className="w-10 h-10 sm:w-12 sm:h-12" />
                                </div>

                                <div>
                                    <h3 className='text-white text-2xl sm:text-3xl lg:text-4xl font-bold'>
                                        {formatNumber(gameCount)}
                                    </h3>

                                    <p className='text-sm font-medium mt-1 bg-gradient-to-r from-[#ff003c] to-[#6a00ff] bg-clip-text text-transparent'>
                                        Game Running
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* CARD 3 */}
                        <div className="card cursor-pointer bg-[#141422] w-full sm:w-[300px] md:w-[320px] lg:w-[340px] rounded-[14px] h-auto sm:h-[130px] lg:h-[142px] flex items-center px-4 sm:px-6 
                        border border-[#ff003c]/30 
                        shadow-[0_10px_25px_rgba(255,0,60,0.15)]
                        hover:shadow-[0_0_25px_rgba(255,0,60,0.4)]
                        transition-all duration-300">

                            <div className='flex items-center gap-4'>
                                <div className='p-3 rounded-lg bg-[#1f1f35]'>
                                    <img src="./assets/images/icon/c3.png" className="w-10 h-10 sm:w-12 sm:h-12" />
                                </div>

                                <div>
                                    <h3 className='text-white text-2xl sm:text-3xl lg:text-4xl font-bold'>
                                        {formatNumber(rewardCount)}
                                    </h3>

                                    <p className='text-sm font-medium mt-1 bg-gradient-to-r from-[#ff003c] to-[#6a00ff] bg-clip-text text-transparent'>
                                        Total Rewards
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* ===== CONTENT ===== */}
            <div className="mt-[150px] sm:mt-[50px] md:mt-[0px]">
                <Trending />
                <NewRelease />
                <RacingGames />
                <MindMining />
            </div>

        </div>
        </>
    );
}

export default ProfileCard;